import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-districtwise-talukawise',
  templateUrl: './districtwise-talukawise.component.html',
  styleUrls: ['./districtwise-talukawise.component.scss'],
})
export class DistrictwiseTalukawiseComponent implements OnInit {
   
  datewisedata;
  today = new Date();
  startdate = '';
  enddate = '';
  datewiselist = [];
  tempdata = [];
 
  
  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
    // { name: 'मुदत ठेव (पंचवार्षिक वर्गणीदार)', isVisible: false },
    // { name: 'रामसेवक ग्रंथयात्री', isVisible: false },
    // { name: 'लोकनेता गंथयात्री वार्षिक', isVisible: false },
    // { name: 'लोकमान्य ग्रंथयात्री वार्षिक वर्गणी', isVisible: false },
    // { name: 'हिंदुत्व ग्रंथयात्री', isVisible: false },
    // { name: 'हिंदुत्व 1', isVisible: false },
    // { name: 'हिंदुत्व 2', isVisible: false },
    // { name: 'आजीव', isVisible: false },
    // { name: 'अनामत', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  state: any;
  country: any;
  taluka: any;
  district:any;
  startDate: any;
  endDate: any;
  appliedFilters: any = {}; 
  

  constructor(
    private dialogref: MatDialogRef<DistrictwiseTalukawiseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    debugger
    this.isLoading = true;
    // this.country = this.data.country;
    // this.state = this.data.state;
     this.district = this.data.district;
     this.taluka = this.data.taluka
    this.datewisedata = this.data['data'];
    console.log( this.datewisedata , "first data")
    // this.datewisedata = this.datewisedata.filter((item:any) =>{
    //    return item.district_name === this.district
    //    })
      //  this.datewisedata = this.datewisedata.filter((item:any) =>{
      //   return item.taluka === this.taluka
      //   })

      
		this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

      const talukaWiseData = this.datewisedata.reduce((acc: any, item: any) => {
        if (!acc[item.rep_taluka]) {
          acc[item.rep_taluka] = [];
        }
        acc[item.rep_taluka].push(item);
        return acc;
      }, {});

console.log("Taluka wIse data ", talukaWiseData)
       console.log(this.datewisedata, "statewise" )
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    // console.log(formatDate(new Date(), 'MMMM', 'en-IN', 'GMT+0530'));
    let data = this.uniqueData(this.datewisedata, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
      
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 3 + 3;
    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 5;
    // this.getDateORrepwiselist();
    this.setData();
  }

  //Correct Code
//   setData() {
//   debugger;
//   let uniqueDateData = this.uniqueData(this.datewisedata, (a) => a.taluka);

//   let finalTotal: any = {};
//   this.subTypesName.map((b: any, i) => {
//     if (b.isVisible) {
//       let name = this.getKey(b.name);
//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       if (i == 0) {
//         finalTotal['name'] = 'एकूण';
//         finalTotal['एकूण'] = 0;
//         finalTotal['नवीन'] = 0;
//         finalTotal['नूतनीकरण'] = 0;
//       }
//     }
//   });

//   // ---- District wise totals container ----
//   let districtTotals: any = {};

//   for (let i = 0; i < uniqueDateData.length; i++) {
//     let datewiseData = this.datewisedata.filter((a) => {
//       return a.taluka === uniqueDateData[i]['taluka'];
//     });

//     let totalData: any = {};
//     this.subTypesName.map((b: any, i) => {
//       if (b.isVisible) {
//         let name = this.getKey(b.name);
//         totalData[name + '_एकूण'] = 0;
//         totalData[name + '_नवीन'] = 0;
//         totalData[name + '_नूतनीकरण'] = 0;
//         if (i == 0) {
//           totalData['एकूण'] = 0;
//           totalData['नवीन'] = 0;
//           totalData['नूतनीकरण'] = 0;
//         }
//       }
//     });

//     datewiseData.map((a: any) => {
//       let name = this.getKey(a.subscription_type);
//       totalData['crdt_voucher_date'] = a.crdt_voucher_date;

//       totalData[name + '_एकूण'] += parseInt(a.total_amt);
//       finalTotal[name + '_एकूण'] += parseInt(a.total_amt);

//       totalData[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
//       finalTotal[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;

//       totalData[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
//       finalTotal[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;

//       totalData['एकूण'] += parseInt(a.total_amt);
//       finalTotal['एकूण'] += parseInt(a.total_amt);

//       totalData['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
//       finalTotal['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;

//       totalData['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
//       finalTotal['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;

//       totalData['taluka'] = a.taluka;
//       totalData['state'] = a.state;
//       totalData['country'] = a.country;
//       totalData['district_name'] = a.district_name;
//     });

//     // ---- Add taluka data ----
//     this.finalData.push(totalData);

//     // ---- Accumulate district totals ----
//     let dKey = totalData['district_name'];
//     if (!districtTotals[dKey]) {
//       districtTotals[dKey] = { ...totalData, taluka: 'जिल्हा एकूण', isDistrictTotal: true };
//     } else {
//       this.subTypesName.map((b: any, i) => {
//         if (b.isVisible) {
//           let name = this.getKey(b.name);
//           districtTotals[dKey][name + '_एकूण'] += totalData[name + '_एकूण'];
//           districtTotals[dKey][name + '_नवीन'] += totalData[name + '_नवीन'];
//           districtTotals[dKey][name + '_नूतनीकरण'] += totalData[name + '_नूतनीकरण'];
//           if (i == 0) {
//             districtTotals[dKey]['एकूण'] += totalData['एकूण'];
//             districtTotals[dKey]['नवीन'] += totalData['नवीन'];
//             districtTotals[dKey]['नूतनीकरण'] += totalData['नूतनीकरण'];
//           }
//         }
//       });
//     }
//   }

//   // ---- Push district totals after sorting talukas ----
//   this.finalData.sort((a, b) => {
//     return a.country?.localeCompare(b.country || '') ||
//            a.state?.localeCompare(b.state || '') ||
//            a.district_name?.localeCompare(b.district_name || '') ||
//            a.taluka?.localeCompare(b.taluka || '');
//   });

//   // Insert district totals just after their talukas
//   let arranged: any[] = [];
//   let groupedByDistrict = this.uniqueData(this.finalData, (a) => a.district_name);
//   groupedByDistrict.forEach((d: any) => {
//     let rows = this.finalData.filter(r => r.district_name === d.district_name && !r.isDistrictTotal);
//     arranged.push(...rows);
//     arranged.push(districtTotals[d.district_name]); // district total
//   });

//   // Replace finalData with arranged data
//   this.finalData = arranged;

//   // ---- Add grand total ----
//   this.finalData.push(finalTotal);

//   console.log(this.finalData);
//   this.isLoading = false;
// }

setData() {
  debugger;
  let uniqueDateData = this.uniqueData(this.datewisedata, (a) => a.taluka);

  let finalTotal: any = {};
  this.subTypesName.map((b: any, i) => {
    if (b.isVisible) {
      let name = this.getKey(b.name);
      finalTotal[name + '_एकूण'] = 0;
      finalTotal[name + '_नवीन'] = 0;
      finalTotal[name + '_नूतनीकरण'] = 0;
      if (i == 0) {
        finalTotal['name'] = 'एकूण';
        finalTotal['एकूण'] = 0;
        finalTotal['नवीन'] = 0;
        finalTotal['नूतनीकरण'] = 0;
      }
    }
  });

  // ---- District wise totals container ----
  let districtTotals: any = {};

  for (let i = 0; i < uniqueDateData.length; i++) {
    let datewiseData = this.datewisedata.filter((a) => {
      return a.taluka === uniqueDateData[i]['taluka'];
    });

    let totalData: any = {};
    this.subTypesName.map((b: any, i) => {
      if (b.isVisible) {
        let name = this.getKey(b.name);
        totalData[name + '_एकूण'] = 0;
        totalData[name + '_नवीन'] = 0;
        totalData[name + '_नूतनीकरण'] = 0;
        if (i == 0) {
          totalData['एकूण'] = 0;
          totalData['नवीन'] = 0;
          totalData['नूतनीकरण'] = 0;
        }
      }
    });

    datewiseData.map((a: any) => {
      let name = this.getKey(a.subscription_type);
      totalData['crdt_voucher_date'] = a.crdt_voucher_date;

      totalData[name + '_एकूण'] += parseInt(a.total_amt);
      finalTotal[name + '_एकूण'] += parseInt(a.total_amt);

      totalData[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
      finalTotal[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;

      totalData[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
      finalTotal[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;

      totalData['एकूण'] += parseInt(a.total_amt);
      finalTotal['एकूण'] += parseInt(a.total_amt);

      totalData['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
      finalTotal['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;

      totalData['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
      finalTotal['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;

      totalData['taluka'] = a.taluka;
      totalData['state'] = a.state;
      totalData['country'] = a.country;
      totalData['district_name'] = a.district_name;
    });

    // ---- Add taluka data ----
    this.finalData.push(totalData);

    // ---- Accumulate district totals ----
    let dKey = totalData['district_name'];
    if (!districtTotals[dKey]) {
      districtTotals[dKey] = { ...totalData, isDistrictTotal: true };
    } else {
      this.subTypesName.map((b: any, i) => {
        if (b.isVisible) {
          let name = this.getKey(b.name);
          districtTotals[dKey][name + '_एकूण'] += totalData[name + '_एकूण'];
          districtTotals[dKey][name + '_नवीन'] += totalData[name + '_नवीन'];
          districtTotals[dKey][name + '_नूतनीकरण'] += totalData[name + '_नूतनीकरण'];
          if (i == 0) {
            districtTotals[dKey]['एकूण'] += totalData['एकूण'];
            districtTotals[dKey]['नवीन'] += totalData['नवीन'];
            districtTotals[dKey]['नूतनीकरण'] += totalData['नूतनीकरण'];
          }
        }
      });
    }
  }

  // ---- Push district totals after sorting talukas ----
  this.finalData.sort((a, b) => {
    return a.country?.localeCompare(b.country || '') ||
           a.state?.localeCompare(b.state || '') ||
           a.district_name?.localeCompare(b.district_name || '') ||
           a.taluka?.localeCompare(b.taluka || '');
  });

  // Insert district totals just after their talukas
  let arranged: any[] = [];
  let groupedByDistrict = this.uniqueData(this.finalData, (a) => a.district_name);
  groupedByDistrict.forEach((d: any) => {
    let rows = this.finalData.filter(r => r.district_name === d.district_name && !r.isDistrictTotal);
    arranged.push(...rows);
    arranged.push(districtTotals[d.district_name]); // district total
  });

  // Replace finalData with arranged data
  this.finalData = arranged;

  // ---- Add grand total ----
  this.finalData.push(finalTotal);

  console.log(this.finalData);
  this.isLoading = false;
}


  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section1');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }
   
  show=false 
printPage() {
  this.show = true;
  const printContent = document.getElementById('print-section1')?.outerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page { 
                size: A3 landscape;
                margin: 5mm;
              }
              body { 
                font-family: Arial, sans-serif;
                font-size: 15px;
                margin: 0;
                padding: 5mm;
                line-height: 1.2;
              }
              table { 
                width: 100%;
                border-collapse: collapse;
                page-break-inside: avoid;
              }
              th, td { 
                padding: 2px;
                border: 1px solid black;
                text-align: center;
                font-size: 12px;
                line-height: 1.2;
              }
              .noPrint { display: none; }

              /* ---------------------------------- */
              /* 🅰 OPTION A – Auto-scaling (uncomment to use) */
              /* body {
                transform: scale(0.9);      /* adjust 0.8–1.0 as needed */
                transform-origin: top left;
              } */
              
              /* ---------------------------------- */
              /* 🅱 OPTION B – Dynamic column shrink (default) */
              table { table-layout: auto; }
              th, td { 
                max-width: 120px;          /* adjust max column width */
                white-space: normal;       /* allow wrapping */
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
            }
          </style>
        </head>
        <body>
          <div id="print-section1">
            ${printContent}
          </div>
          <script>
            window.onload = function() { 
              window.print(); 
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}

}
